import type { Subscription } from '../../custom-ui/bridge/methods/events';
import type { RegisterCleanup } from '../types';

export type SubscriptionHandle = {
	unsubscribe: () => void;
};

/**
 * Wraps an event subscription with Bridge cleanup lifecycle registration.
 */
export const trackSubscription = (
	subscription: Subscription,
	registerCleanup: RegisterCleanup,
): SubscriptionHandle => {
	const dispose = registerCleanup(() => subscription.unsubscribe());
	return {
		unsubscribe: () => {
			dispose();
		},
	};
};
